var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalesconsultingAmico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-44",
    d: "M90.92,246.89c-87.85,50.72-87.85,133,0,183.69s230.29,50.72,318.15,0,87.85-133,0-183.69S178.78,196.17,90.92,246.89Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-44",
    d: "M83.79,429.34c9.95,5.82,9.95,15.24,0,21.06s-26.11,5.81-36.06,0-10-15.24,0-21S73.83,423.53,83.79,429.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-44",
    cx: 419,
    cy: 410.97,
    rx: 61.57,
    ry: 35.55,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-44",
    d: "M390.84,342.82,224.5,438.89a9.57,9.57,0,0,1-8.66,0l-2.37-1.37c-2.39-1.38-2.39-3.62,0-5L379.8,336.45a9.57,9.57,0,0,1,8.66,0l2.38,1.37C393.23,339.2,393.23,341.44,390.84,342.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-44",
    points: "163.52 366.32 85.83 411.17 45.09 387.59 122.78 342.74 163.52 366.32",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-44",
    points: "202.22 415.15 137.53 452.5 103.61 432.87 168.3 395.52 202.22 415.15",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tab--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.45,190.65a1.87,1.87,0,0,0,0-.25s0,0,0-.05a1.72,1.72,0,0,0-.22-.59.67.67,0,0,0-.09-.14.44.44,0,0,0-.08-.1,1,1,0,0,0-.18-.18l0,0a1,1,0,0,0-.23-.13,2,2,0,0,0-1.83.23l-157.1,90.46c-1.5.87-2.72,3-2.72,6V414.45a1.85,1.85,0,0,0,1,1.64l.11.08.15.08.23.08a1.39,1.39,0,0,0,.35,0,1.78,1.78,0,0,0,.9-.25l.07-.05h0l2.6-1.5,154.42-89a6,6,0,0,0,2.72-4.72V191C380.47,190.88,380.46,190.76,380.45,190.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,189.83a.67.67,0,0,1,.31.07l.05,0,0,0,0,0,.07.08h0v0l.06.09a.54.54,0,0,1,.05.11l0,0,.08.21v0l0,0a.19.19,0,0,0,0,.08c0,.08,0,.18,0,.27v129.9a5.25,5.25,0,0,1-2.33,4l-154.42,89-2.53,1.46h0l-.07,0-.07,0a1,1,0,0,1-.51.15h0a.65.65,0,0,1-.18,0l0,0h0l-.06,0h0l-.12-.08,0,0h0a1.08,1.08,0,0,1-.57-1v-1.37h0V285.9c0-2.94,1.2-4.69,2.33-5.34L378.13,190.1a1.71,1.71,0,0,1,.82-.27m0-.78a2.43,2.43,0,0,0-1.2.37l-157.1,90.46c-1.5.87-2.72,3-2.72,6v128h0v.59a1.85,1.85,0,0,0,1,1.64l.11.08.15.08.23.08a1.39,1.39,0,0,0,.35,0h0a1.78,1.78,0,0,0,.86-.25l.07-.05h0l2.6-1.5,154.42-89a6,6,0,0,0,2.72-4.72V191c0-.11,0-.23,0-.34a1.87,1.87,0,0,0,0-.25s0,0,0-.05a1.72,1.72,0,0,0-.22-.59.67.67,0,0,0-.09-.14.44.44,0,0,0-.08-.1,1,1,0,0,0-.18-.18l0,0a1,1,0,0,0-.23-.13,1.46,1.46,0,0,0-.63-.14Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.58,189.19a2,2,0,0,0-1.83.23l-157.1,90.46a6,6,0,0,0-2.72,4.72v5.28l-3.48-2v-5.21a6,6,0,0,1,2.72-4.71l157.1-90.47a1.91,1.91,0,0,1,2-.16C376.74,187.59,379,188.88,379.58,189.19Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.46,191c0-1.72-1.22-2.41-2.72-1.55L220.65,279.89a6,6,0,0,0-2.72,4.71v5.29l162.53-93.6Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.74,189.42,220.65,279.89a5.48,5.48,0,0,0-1.91,2l-3.46-2a5.34,5.34,0,0,1,1.89-2l157.1-90.46a1.92,1.92,0,0,1,2-.16c.48.3,2.74,1.58,3.32,1.89A2,2,0,0,0,377.74,189.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.45,287.86v-5.24a5.58,5.58,0,0,1,.83-2.72l3.46,2a5.52,5.52,0,0,0-.81,2.7v5.29Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.64,197.36a2.79,2.79,0,0,0-1.15,2.21c0,.85.52,1.24,1.15.87a2.77,2.77,0,0,0,1.16-2.21C369.8,197.38,369.28,197,368.64,197.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.8,195a2.79,2.79,0,0,0-1.15,2.21c0,.85.52,1.24,1.15.88a2.77,2.77,0,0,0,1.16-2.21C374,195,373.44,194.59,372.8,195Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,192.55a2.79,2.79,0,0,0-1.15,2.21c0,.85.52,1.24,1.15.87a2.77,2.77,0,0,0,1.16-2.21C378.12,192.57,377.6,192.18,377,192.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.91,416.1l-.15-.08-2.87-1.66a2.9,2.9,0,0,1-1.42-2.11c0-.13,0-.26,0-.4v-124l3.48,2V414.45a1.8,1.8,0,0,0,.84,1.55l.09.06,0,0Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.91,416.1l-.15-.08-2.87-1.66a2.9,2.9,0,0,1-1.42-2.11c0-.13,0-.26,0-.4v-124l3.48,2V414.45a1.8,1.8,0,0,0,.84,1.55l.09.06,0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M242.5,311.25a1.1,1.1,0,0,1-.55-2.05l9.58-5.59a1.1,1.1,0,0,1,1.11,1.89l-9.59,5.6A1.08,1.08,0,0,1,242.5,311.25Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.34,336.53a1.12,1.12,0,0,1-.44-.09,1.1,1.1,0,0,1-.63-.76l-7.13-30.85-4.21-.81a1.09,1.09,0,0,1,.41-2.15l4.92.94a1.08,1.08,0,0,1,.86.83l6.95,30.1,26.19-15.12L280.84,289l-7.43,4.34a1.1,1.1,0,0,1-1.11-1.9l9.51-5.55A1.11,1.11,0,0,1,283,286a1.1,1.1,0,0,1,.44,1.1l-6.11,32.44a1.11,1.11,0,0,1-.53.75l-27.91,16.11A1.08,1.08,0,0,1,248.34,336.53Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.68,345.36a2.77,2.77,0,0,1-1.4-.37,4,4,0,0,1-1.69-3.62,9,9,0,0,1,3.85-7.26l12.17-7a1.1,1.1,0,0,1,1.1,1.9l-12.17,7a6.83,6.83,0,0,0-2.75,5.36c0,1,.3,1.55.59,1.72s.81,0,1.06-.18l27-15.56a1.1,1.1,0,0,1,1.09,1.9l-27,15.57A3.76,3.76,0,0,1,247.68,345.36Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.78,356.86a2.79,2.79,0,0,1-1.41-.38,4,4,0,0,1-1.7-3.65,9.08,9.08,0,0,1,3.88-7.33,3.19,3.19,0,0,1,3.29-.17,4,4,0,0,1,1.7,3.64,9.09,9.09,0,0,1-3.89,7.34A3.84,3.84,0,0,1,250.78,356.86Zm2.65-9.71a1.67,1.67,0,0,0-.78.25,6.93,6.93,0,0,0-2.79,5.43c0,1,.32,1.58.61,1.75s.82,0,1.08-.18a6.87,6.87,0,0,0,2.79-5.43c0-1-.31-1.57-.6-1.74A.6.6,0,0,0,253.43,347.15Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.88,345.83a2.81,2.81,0,0,1-1.41-.38,4,4,0,0,1-1.7-3.65,9.09,9.09,0,0,1,3.89-7.33,3.2,3.2,0,0,1,3.28-.18,4,4,0,0,1,1.7,3.66,9.09,9.09,0,0,1-3.89,7.33A3.81,3.81,0,0,1,269.88,345.83Zm2.65-9.71a1.71,1.71,0,0,0-.78.25A6.92,6.92,0,0,0,269,341.8c0,1,.31,1.58.6,1.75s.83,0,1.09-.18a6.89,6.89,0,0,0,2.79-5.42c0-1-.32-1.58-.61-1.75A.55.55,0,0,0,272.53,336.12Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.34,314.69a6.43,6.43,0,0,1-3.22-.85c-2.63-1.52-4.14-4.93-4.14-9.35,0-8,4.91-17.32,10.94-20.8,2.85-1.65,5.66-1.84,7.89-.55,2.63,1.52,4.14,4.93,4.14,9.35,0,8-4.9,17.32-10.93,20.8A9.42,9.42,0,0,1,258.34,314.69Zm8.25-30.19a7.35,7.35,0,0,0-3.57,1.09c-5.42,3.13-9.84,11.61-9.84,18.9,0,3.62,1.11,6.33,3,7.45,1.52.88,3.55.69,5.7-.55,5.43-3.13,9.84-11.61,9.84-18.9,0-3.61-1.11-6.33-3.05-7.45A4.21,4.21,0,0,0,266.59,284.5Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.14,306a1.11,1.11,0,0,1-.66-.22l-4.11-3.06a1.1,1.1,0,0,1,1.31-1.77l3,2.23,5.9-13.93a1.1,1.1,0,0,1,2,.86l-6.45,15.21a1.09,1.09,0,0,1-.73.64A1.35,1.35,0,0,1,261.14,306Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.6,348.25a1.1,1.1,0,0,1-.55-2.05l6.11-3.53a1.1,1.1,0,0,1,1.1,1.91l-6.12,3.53A1.06,1.06,0,0,1,258.6,348.25Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.2,347,239,376.58c-.57.33-1,0-1-.77h0a2.47,2.47,0,0,1,1-2l51.24-29.58c.56-.32,1,0,1,.78h0A2.45,2.45,0,0,1,290.2,347Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.2,354.84,239,384.42c-.57.33-1,0-1-.78h0a2.45,2.45,0,0,1,1-2L290.2,352.1c.56-.33,1,0,1,.77h0A2.49,2.49,0,0,1,290.2,354.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.93 284.71 301.81 295.75 301.81 255.15 320.93 244.11 320.93 284.71",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.93 284.71 301.81 295.75 301.81 255.15 320.93 244.11 320.93 284.71",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.82,283.07l-14.89,8.59V256.79l14.89-8.59Zm-14.71,8.24,14.52-8.38V248.54l-14.52,8.39Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.08 276.91 303.96 276.78 308.38 269.65 310.5 270.73 316.9 259.05 318.79 260.46 318.66 260.7 316.9 259.39 310.5 271.05 308.38 269.97 304.08 276.91",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,264.71c-1.06.6-1.92,0-1.92-1.45a4.57,4.57,0,0,1,1.92-3.65c1.05-.61,1.91,0,1.91,1.44A4.6,4.6,0,0,1,310.8,264.71Zm0-4.86a4.12,4.12,0,0,0-1.73,3.3c0,1.28.77,1.86,1.73,1.31a4.15,4.15,0,0,0,1.73-3.3C312.53,259.89,311.75,259.3,310.8,259.85Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.02 257.55 300.76 262.32 300.76 257.9 309.02 253.14 309.02 257.55",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.22,255.39a.46.46,0,0,1,.22-.07.19.19,0,0,1,.15,0,.19.19,0,0,1,.09.12.8.8,0,0,1,0,.18v.49a2.07,2.07,0,0,1,0,.22,1.09,1.09,0,0,1-.09.23,1.37,1.37,0,0,1-.15.21.76.76,0,0,1-.22.17.4.4,0,0,1-.21.07.19.19,0,0,1-.15,0,.27.27,0,0,1-.09-.12,1.16,1.16,0,0,1,0-.18v-.49a2.23,2.23,0,0,1,0-.23,1,1,0,0,1,.24-.44A.87.87,0,0,1,306.22,255.39Zm1.33-.66a.36.36,0,0,1,.05-.09l.07-.06.2-.12h.06a.08.08,0,0,1,0,.05v0a0,0,0,0,0,0,0l-1.64,3.81a.19.19,0,0,1-.05.09.16.16,0,0,1-.07.07l-.2.11s0,0-.05,0a.05.05,0,0,1,0,0v0a0,0,0,0,1,0,0Zm-1.15,1.56v-.41a.17.17,0,0,0,0-.12s-.07,0-.14,0a.35.35,0,0,0-.13.14.47.47,0,0,0,0,.17.34.34,0,0,1,0,.09v.24a.28.28,0,0,1,0,.08.17.17,0,0,0,0,.12s.07,0,.13,0a.32.32,0,0,0,.14-.14A.47.47,0,0,0,306.4,256.29Zm1.26-.18a.4.4,0,0,1,.21-.07.24.24,0,0,1,.15,0,.23.23,0,0,1,.09.12.48.48,0,0,1,0,.18,1.77,1.77,0,0,1,0,.24,2,2,0,0,1,0,.25.93.93,0,0,1,0,.22.92.92,0,0,1-.09.23.8.8,0,0,1-.15.21.87.87,0,0,1-.21.17.56.56,0,0,1-.21.08.24.24,0,0,1-.15,0,.23.23,0,0,1-.1-.12,1.16,1.16,0,0,1,0-.18V257a1.7,1.7,0,0,1,0-.22.67.67,0,0,1,.1-.23,1.07,1.07,0,0,1,.15-.22A1.2,1.2,0,0,1,307.66,256.11Zm.17.9a.22.22,0,0,0,0-.09v-.24a.19.19,0,0,0,0-.08.19.19,0,0,0,0-.12s-.07,0-.13,0a.25.25,0,0,0-.13.14.48.48,0,0,0,0,.17v.41a.22.22,0,0,0,0,.13s.06,0,.13,0a.29.29,0,0,0,.13-.14A.47.47,0,0,0,307.83,257Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.31,290.55l-13.21,7.63c-.2.11-.35,0-.35-.26a.8.8,0,0,1,.35-.66l13.21-7.63c.19-.11.35,0,.35.26A.84.84,0,0,1,315.31,290.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.26,290.73l-1.46-1.11c-.29-.22-.29-.85,0-1.41s.76-.83,1.06-.61l.4.3.4-.76c.29-.56.76-.83,1-.61s.3.85,0,1.41Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.49,297.78l-4.39,2.53c-.2.11-.35,0-.35-.26a.81.81,0,0,1,.35-.66l4.39-2.54c.19-.11.35,0,.35.27A.84.84,0,0,1,306.49,297.78Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,295.19l-3,1.72c-.19.11-.35,0-.35-.27A.84.84,0,0,1,308,296l3-1.72c.19-.11.35,0,.35.26A.86.86,0,0,1,311,295.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.84 269.75 327.72 280.79 327.72 240.19 346.84 229.15 346.84 269.75",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.84 269.75 327.72 280.79 327.72 240.19 346.84 229.15 346.84 269.75",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.73,268.11l-14.89,8.59V241.83l14.89-8.59ZM330,276.36,344.54,268V233.59L330,242Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.99 261.95 329.87 261.82 334.29 254.7 336.4 255.77 342.81 244.09 344.7 245.5 344.57 245.74 342.81 244.43 336.41 256.09 334.29 255.01 329.99 261.95",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.71,249.75c-1.06.61-1.92,0-1.92-1.45a4.58,4.58,0,0,1,1.92-3.65c1.05-.61,1.91,0,1.91,1.44A4.6,4.6,0,0,1,336.71,249.75Zm0-4.86A4.13,4.13,0,0,0,335,248.2c0,1.27.77,1.85,1.73,1.3a4.15,4.15,0,0,0,1.73-3.3C338.44,244.93,337.66,244.34,336.71,244.89Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.93 242.59 326.67 247.36 326.67 242.94 334.93 238.18 334.93 242.59",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.13,240.43a.46.46,0,0,1,.22-.07.24.24,0,0,1,.15,0,.23.23,0,0,1,.09.12.8.8,0,0,1,0,.18v.49a2.07,2.07,0,0,1,0,.22.92.92,0,0,1-.09.23.8.8,0,0,1-.15.21.76.76,0,0,1-.22.17.56.56,0,0,1-.21.08.24.24,0,0,1-.15,0,.27.27,0,0,1-.09-.12,1.16,1.16,0,0,1,0-.18c0-.08,0-.16,0-.24s0-.17,0-.25a2.23,2.23,0,0,1,0-.23,1,1,0,0,1,.24-.44A.87.87,0,0,1,332.13,240.43Zm1.33-.66.05-.09.07-.06.2-.12h.06a.08.08,0,0,1,0,.06v0a0,0,0,0,0,0,0l-1.64,3.81a.19.19,0,0,1,0,.09.16.16,0,0,1-.07.07l-.2.11a0,0,0,0,1-.06,0,.06.06,0,0,1,0-.05v0a.06.06,0,0,1,0,0Zm-1.15,1.56v-.41a.17.17,0,0,0,0-.12s-.07,0-.14,0a.35.35,0,0,0-.13.14.47.47,0,0,0,0,.17s0,0,0,.09v.24s0,.06,0,.08a.17.17,0,0,0,0,.12s.07,0,.13,0a.32.32,0,0,0,.14-.14A.47.47,0,0,0,332.31,241.33Zm1.26-.18a.52.52,0,0,1,.21-.07.24.24,0,0,1,.15,0,.27.27,0,0,1,.09.12.48.48,0,0,1,0,.18,1.77,1.77,0,0,1,0,.24,2,2,0,0,1,0,.25.93.93,0,0,1,0,.22.92.92,0,0,1-.09.23.8.8,0,0,1-.15.21.87.87,0,0,1-.21.17.56.56,0,0,1-.21.08.29.29,0,0,1-.16,0,.27.27,0,0,1-.09-.12,1.16,1.16,0,0,1,0-.18V242a1.7,1.7,0,0,1,0-.22.92.92,0,0,1,.09-.23,1.77,1.77,0,0,1,.16-.22A1.2,1.2,0,0,1,333.57,241.15Zm.17.9a.22.22,0,0,0,0-.09v-.24a.19.19,0,0,0,0-.08.19.19,0,0,0,0-.12s-.07,0-.13,0a.25.25,0,0,0-.13.14.53.53,0,0,0-.05.18v.4a.22.22,0,0,0,.05.13s.06,0,.13,0a.29.29,0,0,0,.13-.14A.47.47,0,0,0,333.74,242.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.22,275.59,328,283.22c-.2.11-.35,0-.35-.26a.8.8,0,0,1,.35-.66l13.21-7.63c.19-.11.35,0,.35.26A.84.84,0,0,1,341.22,275.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.17,275.77l-1.46-1.11c-.29-.22-.29-.85,0-1.41s.76-.83,1.06-.61l.4.31.4-.77c.29-.56.76-.83,1.05-.61s.3.85,0,1.41Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.4,282.82,328,285.36c-.2.11-.35,0-.35-.27a.81.81,0,0,1,.35-.66l4.39-2.54c.19-.11.35,0,.35.27A.84.84,0,0,1,332.4,282.82Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.89,280.23l-3,1.72c-.19.11-.35,0-.35-.26a.84.84,0,0,1,.35-.67l3-1.72c.19-.11.35,0,.35.26A.84.84,0,0,1,336.89,280.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.75 254.79 353.63 265.83 353.63 225.23 372.75 214.19 372.75 254.79",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.75 254.79 353.63 265.83 353.63 225.23 372.75 214.19 372.75 254.79",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.64,253.15l-14.89,8.6V226.87l14.89-8.59Zm-14.71,8.25L370.45,253V218.63L355.93,227Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.9 246.99 355.78 246.86 360.2 239.74 362.31 240.81 368.72 229.13 370.61 230.54 370.48 230.78 368.72 229.47 362.32 241.13 360.2 240.05 355.9 246.99",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.62,234.79c-1.06.61-1.92,0-1.92-1.45a4.58,4.58,0,0,1,1.92-3.65c1.05-.61,1.91,0,1.91,1.44A4.6,4.6,0,0,1,362.62,234.79Zm0-4.86a4.13,4.13,0,0,0-1.73,3.31c0,1.27.77,1.85,1.73,1.3a4.15,4.15,0,0,0,1.73-3.3C364.35,230,363.57,229.38,362.62,229.93Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.84 227.64 352.58 232.4 352.58 227.99 360.84 223.22 360.84 227.64",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,225.47a.46.46,0,0,1,.22-.07.24.24,0,0,1,.15,0,.27.27,0,0,1,.09.12.8.8,0,0,1,0,.18v.49a2.07,2.07,0,0,1,0,.22.92.92,0,0,1-.09.23.8.8,0,0,1-.15.21.76.76,0,0,1-.22.17.56.56,0,0,1-.21.08.24.24,0,0,1-.15,0,.27.27,0,0,1-.09-.12,1.16,1.16,0,0,1,0-.18c0-.08,0-.16,0-.24s0-.17,0-.25a1.7,1.7,0,0,1,0-.22.92.92,0,0,1,.09-.23,1.07,1.07,0,0,1,.15-.22A1.2,1.2,0,0,1,358,225.47Zm1.33-.66.05-.09.07-.06.2-.12h.06s0,0,0,.05v0a0,0,0,0,0,0,0l-1.64,3.82a.56.56,0,0,1-.05.08.16.16,0,0,1-.07.07l-.2.11a0,0,0,0,1-.06,0,.06.06,0,0,1,0,0v0a.08.08,0,0,1,0,0Zm-1.15,1.56V226a.19.19,0,0,0,0-.12s-.07,0-.14,0a.35.35,0,0,0-.13.14.53.53,0,0,0,0,.17s0,.05,0,.09v.24s0,.06,0,.08a.22.22,0,0,0,0,.13s.07,0,.13,0a.32.32,0,0,0,.14-.14A.47.47,0,0,0,358.22,226.37Zm1.26-.18a.52.52,0,0,1,.21-.07.24.24,0,0,1,.15,0,.27.27,0,0,1,.09.12.58.58,0,0,1,0,.18c0,.07,0,.15,0,.24s0,.17,0,.25a.93.93,0,0,1,0,.22.92.92,0,0,1-.09.23.8.8,0,0,1-.15.21.87.87,0,0,1-.21.17.56.56,0,0,1-.21.08.29.29,0,0,1-.16,0,.27.27,0,0,1-.09-.12,1.16,1.16,0,0,1,0-.18V227a2.07,2.07,0,0,1,0-.22.92.92,0,0,1,.09-.23,1.77,1.77,0,0,1,.16-.22A1.2,1.2,0,0,1,359.48,226.19Zm.17.9s0-.05,0-.09v-.23s0-.07,0-.09a.21.21,0,0,0,0-.12s-.07,0-.13,0a.37.37,0,0,0-.14.14,1,1,0,0,0,0,.18v.4a.33.33,0,0,0,0,.13s.07,0,.14,0a.25.25,0,0,0,.13-.14A.47.47,0,0,0,359.65,227.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.13,260.63l-13.21,7.63c-.2.11-.35,0-.35-.26a.8.8,0,0,1,.35-.66l13.21-7.63c.19-.11.35,0,.35.26A.82.82,0,0,1,367.13,260.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.08,260.81l-1.46-1.1c-.29-.23-.29-.86,0-1.42s.76-.83,1.06-.61l.4.31.4-.77c.29-.56.76-.83,1-.61s.3.85,0,1.41Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.31,267.86l-4.39,2.54c-.2.11-.35,0-.35-.27a.81.81,0,0,1,.35-.66l4.39-2.53c.19-.12.35,0,.35.26A.84.84,0,0,1,358.31,267.86Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.8,265.27l-3,1.72c-.19.11-.35,0-.35-.26a.84.84,0,0,1,.35-.67l3-1.72c.19-.11.35,0,.35.27A.84.84,0,0,1,362.8,265.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.93 340.96 301.81 352 301.81 311.4 320.93 300.37 320.93 340.96",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.93 340.96 301.81 352 301.81 311.4 320.93 300.37 320.93 340.96",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.82,339.32l-14.89,8.6V313l14.89-8.59Zm-14.71,8.25,14.52-8.39V304.8l-14.52,8.38Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.08 333.16 303.96 333.04 308.38 325.91 310.5 326.99 316.9 315.3 318.79 316.71 318.66 316.96 316.9 315.64 310.5 327.31 308.38 326.22 304.08 333.16",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,321c-1.06.61-1.92,0-1.92-1.45a4.58,4.58,0,0,1,1.92-3.65c1.05-.61,1.91,0,1.91,1.44A4.6,4.6,0,0,1,310.8,321Zm0-4.86a4.14,4.14,0,0,0-1.73,3.31c0,1.27.77,1.86,1.73,1.31a4.19,4.19,0,0,0,1.73-3.31C312.53,316.14,311.75,315.55,310.8,316.1Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.02 313.81 300.76 318.57 300.76 314.16 309.02 309.39 309.02 313.81",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.22,311.64a.61.61,0,0,1,.22-.07.24.24,0,0,1,.15,0,.27.27,0,0,1,.09.12,1.16,1.16,0,0,1,0,.18v.49a2.07,2.07,0,0,1,0,.22.92.92,0,0,1-.09.23.8.8,0,0,1-.15.21.76.76,0,0,1-.22.17.56.56,0,0,1-.21.08.24.24,0,0,1-.15,0,.27.27,0,0,1-.09-.12,1.16,1.16,0,0,1,0-.18v-.49a2.07,2.07,0,0,1,0-.22.92.92,0,0,1,.09-.23,1.07,1.07,0,0,1,.15-.22A1.2,1.2,0,0,1,306.22,311.64Zm1.33-.66.05-.09.07-.06.2-.11a0,0,0,0,1,.06,0s0,0,0,.05v0a0,0,0,0,0,0,0l-1.64,3.82a.41.41,0,0,1-.05.09.22.22,0,0,1-.07.06l-.2.11s0,0-.05,0,0,0,0,0v0a0,0,0,0,1,0,0Zm-1.15,1.56v-.41a.21.21,0,0,0,0-.12s-.07,0-.14,0a.43.43,0,0,0-.13.14.53.53,0,0,0,0,.18.32.32,0,0,1,0,.08v.24a.32.32,0,0,1,0,.08.22.22,0,0,0,0,.13s.07,0,.13,0a.27.27,0,0,0,.14-.14A.47.47,0,0,0,306.4,312.54Zm1.26-.18a.52.52,0,0,1,.21-.07.24.24,0,0,1,.15,0,.27.27,0,0,1,.09.12.58.58,0,0,1,0,.18,1.93,1.93,0,0,1,0,.24,2,2,0,0,1,0,.25.85.85,0,0,1,0,.22.92.92,0,0,1-.09.23.8.8,0,0,1-.15.21.68.68,0,0,1-.21.17.43.43,0,0,1-.21.08.24.24,0,0,1-.15,0,.2.2,0,0,1-.1-.12.8.8,0,0,1,0-.18v-.49a2.07,2.07,0,0,1,0-.22.67.67,0,0,1,.1-.23.8.8,0,0,1,.15-.21A.91.91,0,0,1,307.66,312.36Zm.17.9a.19.19,0,0,0,0-.08v-.24a.22.22,0,0,0,0-.09.21.21,0,0,0,0-.12s-.07,0-.13,0a.29.29,0,0,0-.13.14.61.61,0,0,0,0,.18v.4a.22.22,0,0,0,0,.13s.06,0,.13,0a.27.27,0,0,0,.13-.13A.58.58,0,0,0,307.83,313.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.31,346.8l-13.21,7.63c-.2.11-.35,0-.35-.26a.81.81,0,0,1,.35-.66l13.21-7.63c.19-.11.35,0,.35.26A.82.82,0,0,1,315.31,346.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.26,347l-1.46-1.1c-.29-.22-.29-.86,0-1.41s.76-.84,1.06-.61l.4.3.4-.77c.29-.55.76-.83,1-.61s.3.85,0,1.41Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.49,354l-4.39,2.54c-.2.11-.35,0-.35-.26a.82.82,0,0,1,.35-.67l4.39-2.53c.19-.11.35,0,.35.26A.84.84,0,0,1,306.49,354Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,351.44l-3,1.72c-.19.11-.35,0-.35-.26a.82.82,0,0,1,.35-.66l3-1.73c.19-.11.35,0,.35.27A.84.84,0,0,1,311,351.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.84 326 327.72 337.04 327.72 296.45 346.84 285.41 346.84 326",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.84 326 327.72 337.04 327.72 296.45 346.84 285.41 346.84 326",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.73,324.36,329.84,333V298.08l14.89-8.59ZM330,332.61l14.52-8.38V289.84L330,298.22Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.99 318.2 329.87 318.08 334.29 310.95 336.4 312.03 342.81 300.34 344.7 301.75 344.57 302 342.81 300.68 336.41 312.35 334.29 311.26 329.99 318.2",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.71,306c-1.06.61-1.92,0-1.92-1.45a4.58,4.58,0,0,1,1.92-3.65c1.05-.61,1.91,0,1.91,1.45A4.6,4.6,0,0,1,336.71,306Zm0-4.86a4.14,4.14,0,0,0-1.73,3.31c0,1.27.77,1.86,1.73,1.31a4.17,4.17,0,0,0,1.73-3.31C338.44,301.18,337.66,300.59,336.71,301.14Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.93 298.85 326.67 303.62 326.67 299.2 334.93 294.43 334.93 298.85",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.13,296.68a.61.61,0,0,1,.22-.07.24.24,0,0,1,.15,0,.27.27,0,0,1,.09.12,1.16,1.16,0,0,1,0,.18v.49a1.7,1.7,0,0,1,0,.22.92.92,0,0,1-.09.23.8.8,0,0,1-.15.21.62.62,0,0,1-.22.17.43.43,0,0,1-.21.08.24.24,0,0,1-.15,0,.27.27,0,0,1-.09-.12.8.8,0,0,1,0-.18c0-.07,0-.15,0-.24s0-.17,0-.25a2.07,2.07,0,0,1,0-.22.92.92,0,0,1,.09-.23.8.8,0,0,1,.15-.21A.91.91,0,0,1,332.13,296.68Zm1.33-.66.05-.09.07-.06.2-.11a0,0,0,0,1,.06,0,.06.06,0,0,1,0,.05v0s0,0,0,0l-1.64,3.81a.41.41,0,0,1,0,.09.22.22,0,0,1-.07.06l-.2.11a0,0,0,0,1-.06,0s0,0,0-.05v0a0,0,0,0,1,0,0Zm-1.15,1.56v-.41a.21.21,0,0,0,0-.12s-.07,0-.14,0a.43.43,0,0,0-.13.14.58.58,0,0,0,0,.18s0,0,0,.08v.24a.54.54,0,0,0,0,.08.22.22,0,0,0,0,.13s.07,0,.13,0a.3.3,0,0,0,.14-.13A.58.58,0,0,0,332.31,297.58Zm1.26-.17a.43.43,0,0,1,.21-.08.24.24,0,0,1,.15,0,.27.27,0,0,1,.09.12.58.58,0,0,1,0,.18,1.93,1.93,0,0,1,0,.24,2,2,0,0,1,0,.25,1,1,0,0,1,0,.23,1,1,0,0,1-.24.44.83.83,0,0,1-.21.16.43.43,0,0,1-.21.08.29.29,0,0,1-.16,0,.19.19,0,0,1-.09-.12.8.8,0,0,1,0-.18v-.49a2.07,2.07,0,0,1,0-.22.92.92,0,0,1,.09-.23,1.16,1.16,0,0,1,.16-.21A.68.68,0,0,1,333.57,297.41Zm.17.89a.19.19,0,0,0,0-.08V298s0-.07,0-.08a.22.22,0,0,0,0-.13s-.07,0-.13,0a.24.24,0,0,0-.13.13.61.61,0,0,0-.05.18v.4a.22.22,0,0,0,.05.13s.06,0,.13,0a.27.27,0,0,0,.13-.13A.58.58,0,0,0,333.74,298.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.22,331.84,328,339.47c-.2.11-.35,0-.35-.26a.81.81,0,0,1,.35-.66l13.21-7.63c.19-.11.35,0,.35.26A.82.82,0,0,1,341.22,331.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.17,332l-1.46-1.1c-.29-.22-.29-.85,0-1.41s.76-.83,1.06-.61l.4.3.4-.77c.29-.55.76-.83,1.05-.61s.3.86,0,1.41Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.4,339.07,328,341.61c-.2.11-.35,0-.35-.26a.83.83,0,0,1,.35-.67l4.39-2.53c.19-.11.35,0,.35.26A.82.82,0,0,1,332.4,339.07Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.89,336.48l-3,1.72c-.19.11-.35,0-.35-.26a.82.82,0,0,1,.35-.66l3-1.72c.19-.11.35,0,.35.26A.84.84,0,0,1,336.89,336.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.75 311.04 353.63 322.08 353.63 281.49 372.75 270.45 372.75 311.04",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.75 311.04 353.63 322.08 353.63 281.49 372.75 270.45 372.75 311.04",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.64,309.4,355.75,318V283.12l14.89-8.59Zm-14.71,8.25,14.52-8.38V274.88l-14.52,8.38Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.9 303.24 355.78 303.12 360.2 295.99 362.31 297.07 368.72 285.38 370.61 286.79 370.48 287.04 368.72 285.72 362.32 297.39 360.2 296.3 355.9 303.24",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.62,291c-1.06.61-1.92,0-1.92-1.44a4.59,4.59,0,0,1,1.92-3.66c1.05-.61,1.91,0,1.91,1.45A4.6,4.6,0,0,1,362.62,291Zm0-4.86a4.16,4.16,0,0,0-1.73,3.31c0,1.27.77,1.86,1.73,1.31a4.17,4.17,0,0,0,1.73-3.31C364.35,286.22,363.57,285.63,362.62,286.18Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.84 283.89 352.58 288.66 352.58 284.24 360.84 279.47 360.84 283.89",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,281.73a.49.49,0,0,1,.22-.08.24.24,0,0,1,.15,0,.27.27,0,0,1,.09.12,1.16,1.16,0,0,1,0,.18v.49a1.7,1.7,0,0,1,0,.22.92.92,0,0,1-.09.23,1.07,1.07,0,0,1-.15.22.73.73,0,0,1-.22.16.43.43,0,0,1-.21.08.24.24,0,0,1-.15,0,.23.23,0,0,1-.09-.12.8.8,0,0,1,0-.18c0-.07,0-.15,0-.24s0-.17,0-.25a2.07,2.07,0,0,1,0-.22.92.92,0,0,1,.09-.23.8.8,0,0,1,.15-.21A.68.68,0,0,1,358,281.73Zm1.33-.66a.36.36,0,0,1,.05-.09.23.23,0,0,1,.07-.07l.2-.11a0,0,0,0,1,.06,0,.06.06,0,0,1,0,0v0a.06.06,0,0,0,0,0l-1.64,3.81-.05.09a.22.22,0,0,1-.07.06l-.2.12h-.06s0,0,0-.05v0a0,0,0,0,1,0,0Zm-1.15,1.55v-.4a.22.22,0,0,0,0-.13s-.07,0-.14,0a.43.43,0,0,0-.13.14.58.58,0,0,0,0,.18s0,.05,0,.08v.24a.54.54,0,0,0,0,.08.22.22,0,0,0,0,.13s.07,0,.13,0a.3.3,0,0,0,.14-.13A.58.58,0,0,0,358.22,282.62Zm1.26-.17a.56.56,0,0,1,.21-.08.24.24,0,0,1,.15,0,.27.27,0,0,1,.09.12.58.58,0,0,1,0,.18c0,.08,0,.16,0,.24s0,.17,0,.25a1,1,0,0,1,0,.23,1,1,0,0,1-.24.44,1.2,1.2,0,0,1-.21.17.52.52,0,0,1-.21.07.29.29,0,0,1-.16,0A.19.19,0,0,1,359,284a.8.8,0,0,1,0-.18v-.49a2.07,2.07,0,0,1,0-.22,1.09,1.09,0,0,1,.09-.23,1.66,1.66,0,0,1,.16-.21A.68.68,0,0,1,359.48,282.45Zm.17.89s0,0,0-.08V283a.54.54,0,0,0,0-.08.22.22,0,0,0,0-.13s-.07,0-.13,0a.3.3,0,0,0-.14.13,1.16,1.16,0,0,0,0,.18v.41a.34.34,0,0,0,0,.12s.07,0,.14,0a.34.34,0,0,0,.13-.14A.58.58,0,0,0,359.65,283.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.13,316.89l-13.21,7.63c-.2.11-.35,0-.35-.27a.81.81,0,0,1,.35-.66L367.13,316c.19-.11.35,0,.35.26A.84.84,0,0,1,367.13,316.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.08,317.06l-1.46-1.1c-.29-.22-.29-.85,0-1.41s.76-.83,1.06-.61l.4.3.4-.76c.29-.56.76-.84,1-.62s.3.86,0,1.42Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.31,324.11l-4.39,2.54c-.2.11-.35,0-.35-.26a.8.8,0,0,1,.35-.66l4.39-2.54c.19-.11.35,0,.35.26A.82.82,0,0,1,358.31,324.11Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.8,321.52l-3,1.72c-.19.11-.35,0-.35-.26a.82.82,0,0,1,.35-.66l3-1.72c.19-.11.35,0,.35.26A.84.84,0,0,1,362.8,321.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bags--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bag--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "155.67 366.59 142.17 248.86 134.86 248.09 131 242.43 122.33 347.35 155.67 366.59",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.67 366.59 142.17 248.86 134.86 248.09 131 242.43 122.33 347.35 155.67 366.59",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.86 248.09 134.7 253.17 129.88 255.96 131 242.43 134.86 248.09",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.86 248.09 134.7 253.17 129.88 255.96 131 242.43 134.86 248.09",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.16,282.75,52.49,387.67l69.83-40.33L131,242.43Zm19.55,3.75c-1.1.63-2,.11-2-1.17a4.39,4.39,0,0,1,2-3.45c1.1-.63,2-.12,2,1.17A4.37,4.37,0,0,1,80.71,286.5ZM114.44,267c-1.1.62-2,.1-2-1.18a4.42,4.42,0,0,1,2-3.45c1.1-.64,2-.11,2,1.17A4.4,4.4,0,0,1,114.44,267Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.16,282.75,52.49,387.67l69.83-40.33L131,242.43Zm19.55,3.75c-1.1.63-2,.11-2-1.17a4.39,4.39,0,0,1,2-3.45c1.1-.63,2-.12,2,1.17A4.37,4.37,0,0,1,80.71,286.5ZM114.44,267c-1.1.62-2,.1-2-1.18a4.42,4.42,0,0,1,2-3.45c1.1-.64,2-.11,2,1.17A4.4,4.4,0,0,1,114.44,267Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.16 282.75 69.16 283.68 72.33 289.18 85.83 406.92 52.49 387.67 61.16 282.75",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.16 282.75 69.16 283.68 72.33 289.18 85.83 406.92 52.49 387.67 61.16 282.75",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.16 382.09 69.16 283.68 61.16 282.75 52.49 387.67 69.16 382.09",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.16 382.09 69.16 283.68 61.16 282.75 52.49 387.67 69.16 382.09",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.83 406.92 69.16 382.09 52.49 387.67 85.83 406.92",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.17,248.86,72.33,289.18l13.5,117.73,69.84-40.32ZM92.7,292.77a1.38,1.38,0,0,1-2.17-1.09A3.37,3.37,0,0,1,92,288.47a1.37,1.37,0,0,1,2.17,1.09A3.35,3.35,0,0,1,92.7,292.77Zm34.2-19.62a1.5,1.5,0,0,1-2.28-1.07,3,3,0,0,1,1.14-3.17A1.48,1.48,0,0,1,128,270,3,3,0,0,1,126.9,273.15Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.36,291.36a.64.64,0,0,1-.65-.64V268.17c0-12.64,7.74-27.39,17.25-32.88,4.28-2.47,8.44-2.79,11.72-.9,3.92,2.26,6.17,7.45,6.17,14.23v22.55a.64.64,0,1,1-1.28,0V248.62c0-6.31-2-11.09-5.53-13.12-2.86-1.65-6.57-1.33-10.44.9-9.15,5.28-16.6,19.54-16.6,31.77v22.55A.64.64,0,0,1,92.36,291.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.58,284a.64.64,0,0,1-.64-.64V260.82c0-12.64,7.73-27.39,17.24-32.88,4.28-2.47,8.45-2.79,11.73-.89,3.92,2.26,6.16,7.45,6.16,14.23v22.55a.65.65,0,0,1-1.29,0V241.28c0-6.31-2-11.1-5.52-13.12-2.87-1.66-6.58-1.34-10.45.89-9.15,5.29-16.6,19.54-16.6,31.77v22.56A.64.64,0,0,1,80.58,284Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bag--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "195.63 415.23 184.35 316.91 178.25 316.27 175.02 311.54 167.78 399.16 195.63 415.23",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.63 415.23 184.35 316.91 178.25 316.27 175.02 311.54 167.78 399.16 195.63 415.23",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.25 316.27 178.12 320.51 174.09 322.84 175.03 311.54 178.25 316.27",
    style: {
      fill: "#ED5802",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,345.21l-7.24,87.62,58.32-33.67L175,311.54ZM133,348.35c-.92.52-1.66.09-1.66-1a3.7,3.7,0,0,1,1.66-2.89c.92-.52,1.67-.09,1.67,1A3.67,3.67,0,0,1,133,348.35ZM161.19,332c-.92.53-1.66.09-1.66-1a3.67,3.67,0,0,1,1.66-2.88c.92-.53,1.67-.09,1.67,1A3.65,3.65,0,0,1,161.19,332Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7,345.21l-7.24,87.62,58.32-33.67L175,311.54ZM133,348.35c-.92.52-1.66.09-1.66-1a3.7,3.7,0,0,1,1.66-2.89c.92-.52,1.67-.09,1.67,1A3.67,3.67,0,0,1,133,348.35ZM161.19,332c-.92.53-1.66.09-1.66-1a3.67,3.67,0,0,1,1.66-2.88c.92-.53,1.67-.09,1.67,1A3.65,3.65,0,0,1,161.19,332Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.7 345.21 123.38 345.99 126.03 350.58 137.3 448.91 109.46 432.83 116.7 345.21",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.7 345.21 123.38 345.99 126.03 350.58 137.3 448.91 109.46 432.83 116.7 345.21",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.38 428.18 123.38 345.99 116.7 345.21 109.46 432.83 123.38 428.18",
    style: {
      fill: "#ED5802",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.3 448.91 123.38 428.18 109.46 432.83 137.3 448.91",
    style: {
      fill: "#ED5802",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.35,316.91,126,350.59l11.27,98.32,58.33-33.68ZM143,353.58a1.15,1.15,0,0,1-1.81-.91,2.8,2.8,0,0,1,1.23-2.68,1.15,1.15,0,0,1,1.82.91A2.79,2.79,0,0,1,143,353.58Zm28.57-16.38a1.25,1.25,0,0,1-1.91-.9,2.49,2.49,0,0,1,1-2.65,1.25,1.25,0,0,1,1.91.9A2.5,2.5,0,0,1,171.61,337.2Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.35,316.91,126,350.59l11.27,98.32,58.33-33.68ZM143,353.58a1.15,1.15,0,0,1-1.81-.91,2.8,2.8,0,0,1,1.23-2.68,1.15,1.15,0,0,1,1.82.91A2.79,2.79,0,0,1,143,353.58Zm28.57-16.38a1.25,1.25,0,0,1-1.91-.9,2.49,2.49,0,0,1,1-2.65,1.25,1.25,0,0,1,1.91.9A2.5,2.5,0,0,1,171.61,337.2Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.22,351.87V333c0-10.56,6.46-22.88,14.4-27.47,3.58-2.06,7-2.32,9.79-.74,3.28,1.89,5.15,6.22,5.15,11.88v18.84a.54.54,0,0,1-1.07,0V316.71c0-5.27-1.68-9.26-4.61-10.95-2.4-1.38-5.49-1.12-8.72.74-7.65,4.42-13.87,16.32-13.87,26.54v18.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.92,346.27a.54.54,0,0,1-.54-.53V326.9c0-10.55,6.46-22.87,14.41-27.46,3.57-2.06,7-2.33,9.79-.75,3.27,1.89,5.15,6.22,5.15,11.89v18.83a.54.54,0,1,1-1.07,0V310.58c0-5.27-1.69-9.26-4.62-11-2.39-1.38-5.49-1.12-8.72.75-7.65,4.41-13.87,16.32-13.87,26.53v18.84A.53.53,0,0,1,132.92,346.27Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.46,443.31c-8.18-8.44-13-29.78-5-36.48H86.06c8,6.7,3.18,28-5,36.48l-.22.23-.28.28c-.23.22-.48.45-.74.66l-.2.16c-.2.16-.4.32-.62.47a11,11,0,0,1-1,.68c-6.74,3.93-17.65,3.93-24.38,0h0a9.68,9.68,0,0,1-1.07-.69c-.2-.14-.38-.29-.57-.43l-.24-.2c-.26-.21-.49-.42-.72-.64s-.21-.21-.32-.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.54,404.14c9.26,5.41,9.26,14.18,0,19.59s-24.29,5.41-33.56,0-9.27-14.18,0-19.59S73.27,398.73,82.54,404.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.08,406.74c6.81,4,6.81,10.41,0,14.39s-17.84,4-24.64,0-6.81-10.42,0-14.39S71.28,402.77,78.08,406.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.44,413.57c6.8-4,17.83-4,24.64,0a11.33,11.33,0,0,1,4.08,3.78,11.41,11.41,0,0,1-4.08,3.78c-6.81,4-17.84,4-24.64,0a11.41,11.41,0,0,1-4.08-3.78A11.33,11.33,0,0,1,53.44,413.57Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.2,374.53c-2.74,3.46-11,5-15.08-3.5-3.85-8-7.93-15.47-9.15-18.41a3.1,3.1,0,0,1,1.68-4.15s-.11-4.53,7.77-2.05S59,353.11,62.93,360.35,65.23,373.13,60.2,374.53Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2,374.53c-2.74,3.46-11,5-15.08-3.5-3.85-8-7.93-15.47-9.15-18.41a3.1,3.1,0,0,1,1.68-4.15s-.11-4.53,7.77-2.05S59,353.11,62.93,360.35,65.23,373.13,60.2,374.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.39,385.84a40.8,40.8,0,0,0-1-4.51,64,64,0,0,0-3.21-8.61,64.89,64.89,0,0,0-10.1-15.67,56.47,56.47,0,0,0-7.55-7.36c-.09-.06-.14.12-.08.17a69.46,69.46,0,0,1,12.05,14.22,70.55,70.55,0,0,1,7.6,16.59c.5,1.64,1,3.28,1.42,4.93s.75,3.39,1.17,5.07c0,.17.31.25.31,0A33,33,0,0,0,64.39,385.84Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.39,385.84a40.8,40.8,0,0,0-1-4.51,64,64,0,0,0-3.21-8.61,64.89,64.89,0,0,0-10.1-15.67,56.47,56.47,0,0,0-7.55-7.36c-.09-.06-.14.12-.08.17a69.46,69.46,0,0,1,12.05,14.22,70.55,70.55,0,0,1,7.6,16.59c.5,1.64,1,3.28,1.42,4.93s.75,3.39,1.17,5.07c0,.17.31.25.31,0A33,33,0,0,0,64.39,385.84Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.13,368.45c-7.15,2.21-12.46-3.37-10.62-12.12s11-18.46,14.5-15.85c2.17-2.17,6.94-1.39,9.19,5.71S82.4,371.55,69.13,368.45Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.13,368.45c-7.15,2.21-12.46-3.37-10.62-12.12s11-18.46,14.5-15.85c2.17-2.17,6.94-1.39,9.19,5.71S82.4,371.55,69.13,368.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.32,345.8a95.55,95.55,0,0,0-4.75,15.72A152.34,152.34,0,0,0,65.81,378c-1.28,10.69-1.5,10.09-1.43,20.85q0,4.46.12,8.93c.06,3.06,0,6.16.27,9.21.1,1.17,1.76.85,1.78-.22.11-5.35-.18-10.73-.24-16.09a37.56,37.56,0,0,1,.1-4.5A224.29,224.29,0,0,1,69.3,364c.51-3,1.08-5.92,1.77-8.85.73-3.08,1.62-6.12,2.43-9.18C73.53,345.8,73.39,345.64,73.32,345.8Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.32,345.8a95.55,95.55,0,0,0-4.75,15.72A152.34,152.34,0,0,0,65.81,378c-1.28,10.69-1.5,10.09-1.43,20.85q0,4.46.12,8.93c.06,3.06,0,6.16.27,9.21.1,1.17,1.76.85,1.78-.22.11-5.35-.18-10.73-.24-16.09a37.56,37.56,0,0,1,.1-4.5A224.29,224.29,0,0,1,69.3,364c.51-3,1.08-5.92,1.77-8.85.73-3.08,1.62-6.12,2.43-9.18C73.53,345.8,73.39,345.64,73.32,345.8Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.59,392.09c-.92,4.63-7.26,8-14.58,4.93S16.25,375,22.84,372.86c-.36-3.45,19.59-6.29,29.46,5.87C59.47,387.57,52.59,392.09,52.59,392.09Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.59,392.09c-.92,4.63-7.26,8-14.58,4.93S16.25,375,22.84,372.86c-.36-3.45,19.59-6.29,29.46,5.87C59.47,387.57,52.59,392.09,52.59,392.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.06,399a34.19,34.19,0,0,0-3-3.27,89,89,0,0,0-6.72-6,89.57,89.57,0,0,0-15.45-9.94,81.44,81.44,0,0,0-9.32-4.24c-.09,0-.06.14,0,.17,2.66,1.26,5.33,2.48,7.91,3.92a90.18,90.18,0,0,1,7.75,4.89,114.06,114.06,0,0,1,13.64,11.16c1.2,1.16,2.35,2.37,3.56,3.52s2.63,2.28,3.83,3.53c.18.18.5.1.31-.17C64.73,401.35,64,400.11,63.06,399Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.06,399a34.19,34.19,0,0,0-3-3.27,89,89,0,0,0-6.72-6,89.57,89.57,0,0,0-15.45-9.94,81.44,81.44,0,0,0-9.32-4.24c-.09,0-.06.14,0,.17,2.66,1.26,5.33,2.48,7.91,3.92a90.18,90.18,0,0,1,7.75,4.89,114.06,114.06,0,0,1,13.64,11.16c1.2,1.16,2.35,2.37,3.56,3.52s2.63,2.28,3.83,3.53c.18.18.5.1.31-.17C64.73,401.35,64,400.11,63.06,399Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.12,386.51c-.12-2.6-13.25-2.46-19.4,2.48s-6.88,9.8-3,11.49c-.67,5.5,8,9.12,15.79,2.25S95.93,387.05,93.12,386.51Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.12,386.51c-.12-2.6-13.25-2.46-19.4,2.48s-6.88,9.8-3,11.49c-.67,5.5,8,9.12,15.79,2.25S95.93,387.05,93.12,386.51Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.19,393.4a32.31,32.31,0,0,0-14.5,12.74c-.2.32.3.94.51.59a37.64,37.64,0,0,1,14-13.25S80.25,393.37,80.19,393.4Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.19,393.4a32.31,32.31,0,0,0-14.5,12.74c-.2.32.3.94.51.59a37.64,37.64,0,0,1,14-13.25S80.25,393.37,80.19,393.4Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.46,408.94c-4.45,4.37.47,9.78,7.68,12.45a25.8,25.8,0,0,0,18.66-.86c3.48-1.74,4.19-2.61,4.19-2.61s-1.7-5.73-3.68-8.82a18.48,18.48,0,0,0-18.18-8.36C70.9,401.92,70.15,405.76,71.46,408.94Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.46,408.94c-4.45,4.37.47,9.78,7.68,12.45a25.8,25.8,0,0,0,18.66-.86c3.48-1.74,4.19-2.61,4.19-2.61s-1.7-5.73-3.68-8.82a18.48,18.48,0,0,0-18.18-8.36C70.9,401.92,70.15,405.76,71.46,408.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M90.12,412.22A47.3,47.3,0,0,0,78.82,408c-3.87-.74-8.63-.77-11.76,2-1.21,1.07-2.82,3.38-1.84,5,.1.17.59.47.7.14a15.8,15.8,0,0,1,1-3,6.17,6.17,0,0,1,2.42-2.28,14.42,14.42,0,0,1,8.19-1.39c4.4.43,8.54,2.19,12.59,3.85C90.16,412.34,90.15,412.24,90.12,412.22Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.12,412.22A47.3,47.3,0,0,0,78.82,408c-3.87-.74-8.63-.77-11.76,2-1.21,1.07-2.82,3.38-1.84,5,.1.17.59.47.7.14a15.8,15.8,0,0,1,1-3,6.17,6.17,0,0,1,2.42-2.28,14.42,14.42,0,0,1,8.19-1.39c4.4.43,8.54,2.19,12.59,3.85C90.16,412.34,90.15,412.24,90.12,412.22Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.68,381.42c-1.11,3.91,3.87,7.56,10.07,5.47s12.65-4,17.93-4.1,8.64-3.54,7.55-5.89-2.37-7.91-15.84-9.5S72.85,370.56,70,374.28,70.43,382.08,72.68,381.42Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.68,381.42c-1.11,3.91,3.87,7.56,10.07,5.47s12.65-4,17.93-4.1,8.64-3.54,7.55-5.89-2.37-7.91-15.84-9.5S72.85,370.56,70,374.28,70.43,382.08,72.68,381.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.71,373.21a16.29,16.29,0,0,0-4.35-.39,26.83,26.83,0,0,0-4.2.34,32.71,32.71,0,0,0-7.91,2.46c-4.74,2.1-9.44,4.84-12.51,9.11a30,30,0,0,0-4,7.42c-.18.5.8.78,1,.33A54.13,54.13,0,0,1,69.16,386a19.87,19.87,0,0,1,5.16-5.38,40.94,40.94,0,0,1,14.28-6.54,28.18,28.18,0,0,1,4.56-.67,43.62,43.62,0,0,1,4.58.17C98,373.62,97.85,373.25,97.71,373.21Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.71,373.21a16.29,16.29,0,0,0-4.35-.39,26.83,26.83,0,0,0-4.2.34,32.71,32.71,0,0,0-7.91,2.46c-4.74,2.1-9.44,4.84-12.51,9.11a30,30,0,0,0-4,7.42c-.18.5.8.78,1,.33A54.13,54.13,0,0,1,69.16,386a19.87,19.87,0,0,1,5.16-5.38,40.94,40.94,0,0,1,14.28-6.54,28.18,28.18,0,0,1,4.56-.67,43.62,43.62,0,0,1,4.58.17C98,373.62,97.85,373.25,97.71,373.21Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.63,403.44c-1.05-4-6.14-6.27-12.79-6.77a17.41,17.41,0,0,0-16.56,8.5c-3.48,5.95-4.93,10.69-2.81,11.47s11.06,2,16.83,2.53,13-.53,17.69-4.92S67.14,404.36,61.63,403.44Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.63,403.44c-1.05-4-6.14-6.27-12.79-6.77a17.41,17.41,0,0,0-16.56,8.5c-3.48,5.95-4.93,10.69-2.81,11.47s11.06,2,16.83,2.53,13-.53,17.69-4.92S67.14,404.36,61.63,403.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.88,402.91a17.55,17.55,0,0,0-7.18-.34,32.19,32.19,0,0,0-6.79,1.57,44,44,0,0,0-6.72,3c-1.13.62-2.23,1.27-3.32,2a24.54,24.54,0,0,0-3,2.06s0,.17,0,.14c1.1-.49,2.12-1.18,3.16-1.77s2.26-1.25,3.41-1.83a48.05,48.05,0,0,1,6.66-2.83,31.63,31.63,0,0,1,7.06-1.51,42.14,42.14,0,0,1,6.74.17C62.42,403.58,62.16,403,61.88,402.91Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.88,402.91a17.55,17.55,0,0,0-7.18-.34,32.19,32.19,0,0,0-6.79,1.57,44,44,0,0,0-6.72,3c-1.13.62-2.23,1.27-3.32,2a24.54,24.54,0,0,0-3,2.06s0,.17,0,.14c1.1-.49,2.12-1.18,3.16-1.77s2.26-1.25,3.41-1.83a48.05,48.05,0,0,1,6.66-2.83,31.63,31.63,0,0,1,7.06-1.51,42.14,42.14,0,0,1,6.74.17C62.42,403.58,62.16,403,61.88,402.91Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.77,413.81c-.63-.13-.77,1.79-.64,2.63s2.45,3.89,7,5.37,11.1,1.33,13.87,1.52,6.84,2,9.51,2.86c6.19,2,10,.11,11.8-1.26a2.9,2.9,0,0,0,.93-2.21c.15-1.84,0-2.23-.2-2.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.86,414.52a36.88,36.88,0,0,1,.59,3.91c.14,1.58.22,3.59-1,4.71a8.72,8.72,0,0,1-6.54,2.19,19.45,19.45,0,0,1-8-1.76c-2.33-1.05-4.19-1.95-6.8-2.09-2.88-.16-6.86-.09-9.67-.69a23,23,0,0,1-6.9-2.31,8.88,8.88,0,0,1-3.84-4.33,6.48,6.48,0,0,1,4.35-6,14.49,14.49,0,0,1,7.34-.67c2.69.33,4.69.92,7.09,1a11.9,11.9,0,0,0,4.89-.59,4.71,4.71,0,0,0,1.74-1.95c.49-.81.71-1.55,1.49-1.53,0,0,12.6,1.4,13.74,1.59,1.29.22.93,2,.88,2.92s0,.83-.05,1.65a11.6,11.6,0,0,0,.38,2.74Q411.74,413.94,411.86,414.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.49,407.81a1.41,1.41,0,0,0-.56-.28c-1.07-.29-2,.68-2.6,1.47a7.58,7.58,0,0,0-.76,1.57,3.91,3.91,0,0,0-.29,2.13c0,.18.15.4.34.38s.23-.22.27-.39a8.57,8.57,0,0,1,1.15-2.78,3.54,3.54,0,0,1,.8-1,3.11,3.11,0,0,1,1.16-.55c.18,0,.91,0,.77-.3a.51.51,0,0,0-.13-.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.66,408.18a2.07,2.07,0,0,0-1.5.24,3,3,0,0,0-1,1.34,4.58,4.58,0,0,0-.51,3.67c.17.35.48.21.63-.07a4.8,4.8,0,0,0,.26-1.12,10.54,10.54,0,0,1,1-2.36,4.27,4.27,0,0,1,.55-.83,1.9,1.9,0,0,1,.54-.4,1.21,1.21,0,0,1,.31-.09h.31c0-.16-.15-.27-.29-.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,407.64a2,2,0,0,0-1,.52,3,3,0,0,0-.55.92,10.27,10.27,0,0,0-.71,2.35,3,3,0,0,0,.22,1.69c.1.21.3.43.51.36s.26-.44.3-.65c.08-.38.09-.78.14-1.16a6.87,6.87,0,0,1,1.76-3.79.23.23,0,0,0,.09-.18c0-.11-.16-.13-.26-.13A2.74,2.74,0,0,0,393,407.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.1,407.73c-1.11-.14-3.63,1.11-5.15,4.4a19.58,19.58,0,0,0-1.38,7.66,11,11,0,0,1-5.85-3.62,6.62,6.62,0,0,1-1.33-2.13,6.85,6.85,0,0,1,1.75-5.08c1.84-1.75,4.48-2.74,8.44-2.5,4.45.26,4.7,1.48,4.7,1.48Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.08,386.59s-2.42,17.57-2.79,21.18c-.16,1.54-3.55,3.23-8.25,2.76-3.31-.33-5.36-2.32-5.66-4s-1.26-22.41-1.26-22.41Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.08,387.49l-5.34-17-15.84,2.94s9.66,18.29,10.92,20C453.9,396.18,462.08,387.49,462.08,387.49Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.27,392.5a12.9,12.9,0,0,1-.22,4.75c-.21,1.57-.44,3.11-.56,4.69a17.1,17.1,0,0,1-.4,2.87,18,18,0,0,0-.13,3.45c0,1.2-.06,2.41-.07,3.62a6.61,6.61,0,0,0,0,1.54c.13.5-7.65,5-10.78,6.68l-.57.27a5,5,0,0,1-5.09-1.19,8.65,8.65,0,0,1,2.11-9.53s.4,0,.32-3c0-2.19,0-4.41-.24-6.58a14,14,0,0,0-1-4c-.48-1.16-1.38-2.39-1.33-3.69a5.57,5.57,0,0,1,1.22-2.57c1.14-2,3.66-3.58,5.68-4.49,1.16-.52,3-1.08,4.22-.36.64.38.94,1.13,1.4,1.73a8.75,8.75,0,0,0,2,1.68,8,8,0,0,1,3.33,3.79C468.21,392.25,468.24,392.38,468.27,392.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.56,409.65a10.41,10.41,0,0,0-1,1.47h0a10.91,10.91,0,0,0-1.09,8.06c-5.49-.5-6.94-3.67-6.94-3.67s-.3-2.74,2.86-4.73a7.19,7.19,0,0,1,1.19-.63l.06,0A8,8,0,0,1,452.56,409.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.55,393.36c1.45.56,1.07,4.52.16,8.34s-1.41,5.15-.94,8.32.73,4.6-.57,5.76-11.59,6-11.59,6a37.86,37.86,0,0,0,2.3-11.93c.27-7,.74-11.56,4-14.76A6.17,6.17,0,0,1,469.55,393.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.51,415.5a19.17,19.17,0,0,0,8.59,3.75c4.6.53,4.83-1.24,5.31-6.68s.67-13,2.81-16.29,5.75-4.79,7.17-4.45c.29-.15,1.7.9,2.16,1.53a7.85,7.85,0,0,0-6,2.41c-2.87,2.81-3.4,8.73-3.53,14.12s-.37,11.62-4.65,12.27a15.59,15.59,0,0,1-11.69-3.55A2.17,2.17,0,0,1,443.51,415.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.89,407.65a1.52,1.52,0,0,0-.64,1,3.07,3.07,0,0,0,1.56,2.82c.58.33,1.07.2.14-.93A5.93,5.93,0,0,1,452.89,407.65Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.79,403.86a1.29,1.29,0,0,0-.38.82,4.71,4.71,0,0,0,1.89,3c1,.45.46-.66,0-1.18A21,21,0,0,1,452.79,403.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.54,399.69a.89.89,0,0,0-.47.67c0,.44,2,2,2.69,1.94s.8-.26,0-.8S452.54,399.69,452.54,399.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.47,386.68S435.29,364.52,428,349.56c-2.51-5.14-3.64-7.35-4.41-11.3s-3.73-14.82-3.73-14.82l-4,23a78.13,78.13,0,0,1,1.82,12.75c.24,4.84-.54,10.47-2.26,21-2.48,15.2-3.57,18.94-3.57,18.94-1.09.82-3.88,1-6.68,1.11-6.49.3-9.6-2.74-9.6-2.74s-1.72-26.76-2.3-32.9c-2-21-2.14-29.85-1.66-54.32.41-20.86,2.66-45.95,2.66-45.95l46.38-11.12s8.53,14.92,7.66,29.52c-.94,15.86-1.45,50.84-1.45,50.84,2.51,4.1,4.75,8.28,7.11,18.32,1.38,5.88,4.08,18.62,6,27.95A14.13,14.13,0,0,0,447.47,386.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.86,323.44l5.9-32.61s6.34-.74,14.7-8.08c0,0-.56,5.72-11.68,10.62l-6.35,29,1.16,15.91Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.56,204c6.44-.76,11.08,1.5,15.62,10.21,4.3,8.23,10.37,20.13,12.71,26.17,1.15,2.94,3,5.52-2.2,11.21A89.1,89.1,0,0,1,443.34,265l-6.49-11.69,7.18-9.52-3.41-7.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,243.81a15.71,15.71,0,0,0,6.58,4.5c-2.44.77-6.79-1.45-7.73-3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.38,176.61s-4.09,6-3.65,6.51a8,8,0,0,0,2.54,1.08Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.78,162c-2.75,1.4-7.56,2.86-9.71,10.8-.37,1.37.18,3.49,0,5.21-.23,1.93-1.07,4.08-1.11,5.63-.22,8.08,2.12,11.19,3.52,12.52,1.12,1.06,6.93,1.45,10,.52,3.79-1.16,12-5.14,15.85-11.35,4.53-7.29,5.46-17,.23-20.83C422.13,159.12,413.52,160.6,410.78,162Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.75,196.36c1.36.75,5.22,1.06,8.1.64l-.09-2.16a20.9,20.9,0,0,1-3.83,1.25A13.86,13.86,0,0,1,403.75,196.36Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.52,159a16.66,16.66,0,0,0-5.14,6.11,11,11,0,0,0,1.63,11.5,8.78,8.78,0,0,1,0-3.35c-.19.95,1.11,2.55,1.71,3.16a12.55,12.55,0,0,0,3.12,2,.48.48,0,0,1,.2.17.59.59,0,0,1,.05.23c0,.46,0,.91,0,1.37a1.86,1.86,0,0,0,.24,1.07,1.19,1.19,0,0,0,1.25.36,2.27,2.27,0,0,0,1.1-.81c.28-.36.51-.77.79-1.13a4,4,0,0,1,3-2,3.43,3.43,0,0,1,3.34,1.8,7,7,0,0,1-.63,5.76c-1,1.52-2.13,2.39-3.32,2.45a3.1,3.1,0,0,1-2.5-1s-.6,6.64,4.79,8.77c0,0,5.95,1.57,11.25-.44.59-.23,1.53-2,2-2.53.82-1,1.68-2,2.53-2.95a31.62,31.62,0,0,0,3.45-5.19c2.3-4,2.9-8.66,2.64-13.31-.2-3.47-2.75-7.26-2.75-7.26C431.39,154,415.64,152,406.52,159Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.43,210.71c-1.19-4.63-2.73-7.67-11.53-7.26l-1.23,0c-3.13.45-7.52.71-15.57,1.32-1,.19-10.62,1.83-12.22,2,0,0-7.19,4.3-10.76,19.47-1,4.3-.51,8.82,4.8,12.94-.13,4.37.84,8.14.3,12.35a175.56,175.56,0,0,0-1.7,20.54s11,5.4,29.14,3.64c11.19-1.08,21.85-7.27,24-9.3,0,0-1.9-7-7.79-18.9C440.6,232.56,445.49,226.61,441.43,210.71Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.31,163.82s4.62,2.29,4.76,11.65c.1,6.63.34,15.41.42,23.83,0,4.24.49,8.26-.59,12.43A26,26,0,0,1,433.75,223q-.13-3.18-.28-6.36a12.1,12.1,0,0,1-3.29,7.81,26.39,26.39,0,0,1-6.89,5.19,31.65,31.65,0,0,0-.36-6.3,9.38,9.38,0,0,0-1.76,4.43,10.32,10.32,0,0,1-3.4-4.94L417,226a.84.84,0,0,1-.23.47c-.25.21-.63.07-.92-.08-3.52-1.83-9.22-11.45-9.12-20.46l-5.84.92a22.27,22.27,0,0,1,4.47-6.42c3.24-3.35,5.85-7.27,6.09-13.7,1.33,3.34,5.48,4.51,9.45,1.9S435.31,163.82,435.31,163.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.93,229.77a84.93,84.93,0,0,1-7-6.36c-.7-.76-.81-2.46-.83-3.5-.08-3.25-1.74-5.66-2.69-8.69-.24-.77-.63-2.12-1.48-2a1.86,1.86,0,0,0-1,.53,2.53,2.53,0,0,0-.53,1.06,5.57,5.57,0,0,0,.12,2.78c.1.37.89,2.15.47,2.4-.15.09-.34,0-.49-.1a16.86,16.86,0,0,1-2.13-1.83c-.66-.59-1.37-1.12-2-1.76a31,31,0,0,1-4-4.84c-1.1-1.38-1.93-1.6-2.74-1.16s.2,2.4.2,2.4a8.71,8.71,0,0,0-2.17-2.3c-1.14-.54-2.43-.32-2.34.65a10.64,10.64,0,0,0,.3,1.16c-.57.2-1.65,1.5-.65,3.32,0,0-1.4.25-.21,3.26a30.76,30.76,0,0,0,10.42,13.5,29.7,29.7,0,0,1,5.45,5.12c4.38,5,8.74,10.3,13.32,15.34Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.85,208.83a19.8,19.8,0,0,0,5.16,7.45C345.17,213.86,343.45,211.41,341.85,208.83Zm-4.25-.59c1.59,4.17,3.86,8.35,7.41,11.16C341.85,216.18,339.71,212.19,337.6,208.24Zm4.69,12.11a40.63,40.63,0,0,1-5.34-8.79A18.17,18.17,0,0,0,342.29,220.35Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.88,206.85c-5.78,1-9.88,6-11.52,8.27-5.29,7.32-14.72,19.43-14.72,19.43l-11.05-7.17s-1.87.29-4.29,3.71-2.08,8.52-2.08,8.52,8.27,9.14,9.92,10.77c7.54,7.5,11.66,5.05,14,3.15,7.5-6.1,17.91-19.41,19.92-21.49C405,228,406.4,213.42,400.88,206.85Z",
    style: {
      fill: "#37474f"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.43,60.4C301,68.8,310,86.82,310,112.48c0,51.3-36,113.68-80.44,139.33-22.22,12.82-42.32,14-56.88,5.63l-24.94-14.39c-14.55-8.41-23.56-26.44-23.56-52.08,0-51.31,36-113.69,80.45-139.34,22.21-12.82,42.32-14,56.88-5.63Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.43,60.4C301,68.8,310,86.82,310,112.48c0,51.3-36,113.68-80.44,139.33-22.22,12.82-42.32,14-56.88,5.63l-24.94-14.39c-14.55-8.41-23.56-26.44-23.56-52.08,0-51.31,36-113.69,80.45-139.34,22.21-12.82,42.32-14,56.88-5.63Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.13,200.41c17.64-27.23,28.86-59.3,28.86-87.93,0-25.66-9-43.68-23.56-52.08L261.5,46c-14.56-8.4-34.67-7.19-56.88,5.63-24.8,14.32-47,40.08-61.73,69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.55,252c-22.22,12.83-42.33,14-56.88,5.63s-23.56-26.43-23.56-52.08c0-51.3,36-113.68,80.44-139.33,22.21-12.82,42.32-14,56.88-5.63S310,87.06,310,112.71C310,164,274,226.39,229.55,252Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.48,57.53h0a39.08,39.08,0,0,1,19.82,5c14.47,8.35,22.44,26.16,22.44,50.13,0,50.5-35.59,112.13-79.32,137.38-12.28,7.09-24,10.68-34.8,10.68a39.15,39.15,0,0,1-19.83-5c-14.46-8.35-22.43-26.15-22.43-50.13,0-50.5,35.58-112.13,79.32-137.38,12.28-7.09,24-10.68,34.8-10.68m0-2.25c-10.82,0-23,3.53-35.93,11-44.43,25.65-80.44,88-80.44,139.33,0,25.65,9,43.68,23.56,52.08a41.37,41.37,0,0,0,21,5.36c10.81,0,23-3.54,35.93-11C274,226.39,310,164,310,112.71c0-25.65-9-43.68-23.56-52.08a41.37,41.37,0,0,0-20.95-5.35Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.7,124.22a9.15,9.15,0,0,1-.47-.94c-.21-.71.13-1.48,0-2.22a2.44,2.44,0,0,0-1.87-1.92,4.28,4.28,0,0,0-2.79.39,7.28,7.28,0,0,1-1.77.76,10.08,10.08,0,0,1-1.82,0c-1.83,0-2.09,1.73-3,3-1.94,2.68-5.54,11.26-8.68,12.59-.64.28-2.06.65-1.59-.52a29.81,29.81,0,0,0,1.68-4.63,5.84,5.84,0,0,0-.82-4.72,2.09,2.09,0,0,0-1.21-.85c-.7-.13-.94.28-1.19.78a14.26,14.26,0,0,1-1,1.47c-.7,1-1.39,2-2.07,3-4,5.88-6.88,9.21-8.71,13.72-1.44,3.55-1.69,7.31-5.35,11.5-3.1,3.56-22,21.6-22,21.6s-4.77-7.22-17.55-25.92c-9.65-14.11-14.13-16.08-19.09-17.4l-.16,42.61A278.18,278.18,0,0,0,294.49,207c9.4,9.31,18.28,3.64,26.57-8.47,5.46-8,21-30.07,24.4-35.41a21.85,21.85,0,0,1,7.69-7.81,34,34,0,0,0,9.24-9.43,49.82,49.82,0,0,0,4-9,25.32,25.32,0,0,0,.8-4.13c.18-1.31-.06-2.62.19-3.94C367.67,127.25,368.38,125.63,367.7,124.22Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M344.53,139.79c2.72,7.6,0,12.49-4,14.88A23.75,23.75,0,0,0,344.53,139.79Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,132.63c9.29,1.67,13.36,4.94,19.22,13.78s19.8,29.5,19.8,29.5l18.2-16.81a18.72,18.72,0,0,0,6.07,10.27,20.81,20.81,0,0,0,9.9,4.62s-16.12,23-22.09,30.9-13.09,12-22,3.52-29-32.36-29-32.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,175.91c-4.81,4.34-9.05,12.56-9.21,19.83-4-12.54,7.05-23,7.05-23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.15,200.5c0,1-.06,2.25-.1,3.7-13.28,19.2-29.77,35.58-47.63,45.89a94.68,94.68,0,0,1-12.27,6,261.51,261.51,0,0,1-30.21-7.36c3.31-21.62,3.91-30.36,4.1-45.43.19-16.62,1-28.33,2.8-40.24,2.21-14.66,4.91-23.91,9.47-25.07,7.09-1.8,30-9.43,36-10.14l23.91,4.25c4.88,2,13,9.21,14,37.08C276.51,176.73,276.28,190.87,276.15,200.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,251.71c-11.22,6-21.93,9.07-31.89,9.07a41.75,41.75,0,0,1-10.81-1.37c1-18.16,4.64-39,4.62-56.28,0-22.31-11.24-59.58,6.91-65.54,0,0,12.25-2.45,16.63-4.39a27.92,27.92,0,0,0,5.73-3.1c0,.16-.33,1.7.5,6,.88,4.51,3.43,8.91,5.47,14.29,4.77,12.54,4.91,22.53,5.13,49.71C227.92,214.28,226.61,235,225.51,251.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.26,137.65q.38,8.55.59,17.08l.23,8.54.14,8.55-.22-.44c3.3,2.46,6.62,4.9,9.9,7.39l.38.29-.19.43-5.88,13v-.4c1.68,4.29,3.27,8.63,4.91,12.94s3.22,8.66,4.77,13q-2.75-6.36-5.4-12.76c-1.75-4.27-3.54-8.52-5.26-12.81l-.08-.2.09-.21L220,179l.19.72c-3.31-2.45-6.57-5-9.86-7.45l-.22-.17v-.27l-.06-8.54,0-8.55Q210.09,146.21,210.26,137.65Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.23,201A186.23,186.23,0,0,1,266,217.43q-.17-4.37-.3-9c-.28-10-.43-29.2-1.73-42.42-1.8-18.22-5.57-24.3-13.76-35.43l-1.92-2.15s8.92,2.3,17.36,4c8.53,6.82,11,19.59,11.43,29.73s1,29.31,1.12,37.6C278.22,200.13,278.22,200.53,278.23,201Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,133.08a56.7,56.7,0,0,1,6.11,7.52,76.07,76.07,0,0,1,5,8.32,77.45,77.45,0,0,1,4,8.87,94.21,94.21,0,0,1,3,9.27l.06.22-.13.21-4.72,7.93v-.62l6.27,10.69.12.19-.05.2-1.91,8-2,7.94c-1.3,5.29-2.67,10.57-4.06,15.84,1.07-5.35,2.17-10.69,3.34-16l1.74-8,1.79-8,.06.4-6.37-10.63-.19-.3.19-.31,4.78-7.89-.06.43a95.62,95.62,0,0,0-2.84-9.19,94.28,94.28,0,0,0-3.73-8.86,91.15,91.15,0,0,0-4.69-8.42A63.64,63.64,0,0,0,256,133.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.92,118.1c-3.55-6.56-6.81-12.21-9.44-18-2.53-5.59-4-9.9-3.42-15,.34-3,2.45-7,4.74-7.8-2-11.4,8.2-15.5,12.75-16.35,1.74-.33,4.88-.43,6.55-.79,1.76-2.23,2.69-3.49,4.92-4.81,2.86-1.71,8.67-1.64,11.07,2.16,2-1.43,4.48-2,8-.89,3.33,1,3.77,3.49,3.93,5.29,4.86-2.42,8.5,1.25,9.33,3.94s-.3,3.78.95,5.68c1.41,2.15,4.27,2.25,5.22.62.35,2.94-.9,5.11-4.05,4.79a6.61,6.61,0,0,1,.54,5.6,6,6,0,0,1-5.66,3.9c-.42,1.58-.56,3-1.63,4.37A10.44,10.44,0,0,1,260.8,94c-4.89,2-10.22,2.52-15.43,3.33l-6.18,1c-.36.06-2.21.08-2.45.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,109.84c4.42,3,7.65.15,7.65.15L220.48,123,220,127.5c-.26,3.64,4.09,8.71,9.67,13.17,7.32,5.84,16.59,14.87,18.06,16.35.66-3.33.62-16-1.62-20.79l1-10a62.25,62.25,0,0,0,7.73,0c5.12-.44,9.61-4.25,11.34-9.68a58.47,58.47,0,0,0,1.77-22,18.8,18.8,0,0,1,0-5.35c.72-4.71,0-7.5-1-11.53-5.37-4.78-21.15-6.5-33.57.24,2.28,6.27.34,12.45-5,14.93.15,2,.14,6.85-3,6.61-2.29-.18-2.3-3.07-4.53-5.72s-7.7-3.61-10,0C207.52,98.81,209.13,106.61,214,109.84Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11,126.19c-8-1.35-14.09-2.53-18-8.58a50.67,50.67,0,0,1-4.38-9.8s.47,7.18,2.86,12.15c1.85,3.83,6.68,7.18,19.26,8.9Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.37,88.4l-4.94-2.64a2.69,2.69,0,0,1,3.7-1.22A2.94,2.94,0,0,1,265.37,88.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.6,94.77A2.5,2.5,0,1,1,263.27,92,2.54,2.54,0,0,1,265.6,94.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.74,94.07a2.5,2.5,0,1,1-2.33-2.75A2.54,2.54,0,0,1,246.74,94.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.35,104.09l-8.41,2,.44-15.68C255.46,89.92,257.87,97.61,260.35,104.09Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.5,86l-5.26,2A3,3,0,0,1,242,84.2,2.73,2.73,0,0,1,245.5,86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.25,108.21l9.17,3.2a4.77,4.77,0,0,1-6.1,3.16A5.08,5.08,0,0,1,245.25,108.21Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.2,109.89a6,6,0,0,0-1.17-.13,5,5,0,0,0,3.29,4.81,4.53,4.53,0,0,0,1.53.24A4.45,4.45,0,0,0,246.2,109.89Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.77,112.89a5.59,5.59,0,0,1-5.79,4.59,9.52,9.52,0,0,1-1.37-.12l.13-.81c3.69.61,5.82-1.54,6.23-3.8.45-2.47-.94-5.47-4.87-7.08,0-.29,0-.58.06-.86C272.69,106.56,274.3,110,273.77,112.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.76,119.44l-3.47-.74a2.75,2.75,0,0,1-2.13-3.26h0a2.77,2.77,0,0,1,3.27-2.13l3.47.74a2.75,2.75,0,0,1,2.12,3.26h0A2.75,2.75,0,0,1,264.76,119.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Neck--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.72,157c1-3.66,3.83-5.93,5.55-6.08,4.38-.38,6.59,5,6.59,5s.41-12.77-5.86-20.77c-5.78-7.39-6.95-8.33-6.95-8.33l-1,9.43a30.11,30.11,0,0,1,1.49,8A94.06,94.06,0,0,1,247.72,157Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.16,126c-2.37.86-2.49,3.89-9.19,7.23A42.69,42.69,0,0,0,233,161c1.4-3.53,1.79-6,5.21-7.35s9.48,3.38,9.48,3.38a17.61,17.61,0,0,0-3.28-4.56c-8.07-6.92-10.15-8.68-14.22-12.06-10.85-9-10.23-12.9-10.23-12.9Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.43,95.64,213,93.92s.18-12.36,1.92-18.77c1.63-6,5.44-11.12,9.07-13a19,19,0,0,1,8.07-2A13.78,13.78,0,0,0,228.23,62c-1.43,1-6.34,5.88-7.87,15.9A85.74,85.74,0,0,0,219.43,95.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.16,108.9c2-5.41.75-13.44-2.85-17.9a8.43,8.43,0,0,0-3.45-2.69,5,5,0,0,0-2.64-.28l-3,.49c-2,.35-3.79,2-4.83,4.81-2,5.4-.75,13.43,2.85,17.9a8.4,8.4,0,0,0,3.45,2.68,5,5,0,0,0,2.66.29l2.94-.49C222.35,113.36,224.12,111.67,225.16,108.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.71,113.91a8.4,8.4,0,0,1-3.45-2.68c-3.6-4.47-4.88-12.5-2.85-17.9,1.47-3.92,4.41-5.7,7.49-4.52a8.34,8.34,0,0,1,3.45,2.69C223,96,224.23,104,222.2,109.39,220.73,113.31,217.79,115.09,214.71,113.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.6,109.16c2-5.22.73-12.94-2.75-17.25-1.74-2.16-3.71-3-5.49-2.75l-1.47.25c-1.79.29-3.38,1.78-4.36,4.39-2,5.22-.73,13,2.75,17.26,1.74,2.16,3.71,3,5.49,2.75l1.48-.25C219,113.26,220.62,111.77,221.6,109.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.37,92.15c3.48,4.31,4.71,12,2.75,17.26s-6.37,6-9.84,1.65-4.71-12-2.75-17.26S213.9,87.84,217.37,92.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.12,109.41c2-5.22.73-13-2.75-17.26-1.73-2.15-3.7-3-5.48-2.74-.5.08-1.42.3-1.91.38-1.78.3-3.37,1.79-4.35,4.39-2,5.23-.73,12.95,2.74,17.26,1.74,2.16,3.71,3,5.49,2.75.5-.08,1.41-.3,1.91-.38C217.55,113.51,219.14,112,220.12,109.41Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.47,92.54c3.48,4.31,4.71,12,2.75,17.25s-6.37,6-9.85,1.65-4.7-12-2.74-17.26S212,88.23,215.47,92.54Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.71,97.38a10.27,10.27,0,0,1,1.44,9.07c-1,2.74-3.35,3.13-5.17.86a10.25,10.25,0,0,1-1.45-9.06C208.56,95.5,210.88,95.12,212.71,97.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.07,100.8l-3.46,1.58-1-6.4a3.15,3.15,0,0,1,2.89,1.44A9,9,0,0,1,214.07,100.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.92,106.49a3.2,3.2,0,0,1-2.29,2.3l-1-6.41,3.46-1.58A10,10,0,0,1,213.92,106.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.63,108.79a3.15,3.15,0,0,1-2.88-1.44,8.82,8.82,0,0,1-1.59-3.38l3.45-1.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.61,102.38,207.16,104a9.83,9.83,0,0,1,.15-5.68A3.19,3.19,0,0,1,209.59,96Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.57,179.63l-12.29,40.79s-.76,6.26-1.94,20.44c-.58,7-1.23,13-1.45,18.82a36.5,36.5,0,0,1-10.09-4c-7.56-4.37-13.34-11.3-17.13-20.34A114.26,114.26,0,0,1,156.1,214c.24-4.42,2.36-13.37,8.77-34s8.09-27,11.52-32.24c2.83-4.33,7.34-8.5,18-10.15C207.49,147.87,199.57,179.63,199.57,179.63Z",
    style: {
      fill: "#37474f"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--phone-icon--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--phone-icon--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.43,64.54C344.1,67.23,347,73,347,81.24c0,16.45-11.55,36.45-25.8,44.68-7.12,4.11-13.57,4.5-18.24,1.8l-8-4.61c-4.67-2.7-7.56-8.48-7.56-16.7C287.4,90,299,70,313.2,61.73c7.12-4.12,13.57-4.5,18.24-1.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.73,109.43c5.66-8.73,9.26-19,9.26-28.19,0-8.23-2.89-14-7.56-16.7l-8-4.62c-4.67-2.69-11.12-2.31-18.24,1.81-7.95,4.59-15.06,12.85-19.8,22.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.19,126c-7.12,4.11-13.57,4.5-18.24,1.81s-7.55-8.48-7.55-16.7c0-16.45,11.55-36.46,25.79-44.68,7.13-4.12,13.58-4.51,18.24-1.81S347,73.09,347,81.31C347,97.76,335.44,117.77,321.19,126Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.93,80c0-1.74-.56-1.55-.93-1.61s-.77-.1-1.18-.13a2.62,2.62,0,0,0-2,1,15.16,15.16,0,0,0-4.4,7.07,19.41,19.41,0,0,0-.23,9.22c.13.61,1.5,9.75,6.57,14.05a22.27,22.27,0,0,0,3,2.13,5.73,5.73,0,0,0,3.8.68,9.46,9.46,0,0,0,5.46-3.78,11.67,11.67,0,0,0,1.63-4.11c0-.37-.39-.63-.88-1.12s-2.89-2.85-3.37-3.19-.85-.52-1.53.32-2.47,2.69-3,3.24-.93.59-1.41.11A12.41,12.41,0,0,1,317.77,99a21.85,21.85,0,0,1-1.6-6.32A1.89,1.89,0,0,1,317,91c.39-.36.93-1,1.39-1.44a8.64,8.64,0,0,0,1.07-1.4,2.34,2.34,0,0,0,.42-1.53C319.84,86.14,319.92,81.75,319.93,80Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-3--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.1,135.61l-3.46-6.52,2.79-8v-4.93L414.89,121V126l3.67,6.35a.55.55,0,0,0,.25.23h0Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.1,135.61l-3.46-6.52,2.79-8v-4.93L414.89,121V126l3.67,6.35a.55.55,0,0,0,.25.23h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.5,70.94a5.69,5.69,0,0,0-2.56-4.44l-2.09-1.2a5.7,5.7,0,0,0-5.12,0l-32,18.49a5.67,5.67,0,0,0-2.56,4.44v41.14a5.67,5.67,0,0,0,2.56,4.44l2.09,1.2a5.64,5.64,0,0,0,5.12,0l10.28-5.94,3.66,6.35a.55.55,0,0,0,1-.1l3.87-11.17,13.17-7.63a5.66,5.66,0,0,0,2.56-4.43Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.2,129.37a5.67,5.67,0,0,0,2.56,4.44l2.09,1.2a5.73,5.73,0,0,0,4.68.21c-1.2.45-2.12-.23-2.12-1.69V92.38a5.16,5.16,0,0,1,.75-2.52L401,85.7a5.27,5.27,0,0,0-.75,2.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.41,70.21c-.3-1.09-1.29-1.43-2.47-.75L410,88a5.13,5.13,0,0,0-1.81,1.91L401,85.71a5.19,5.19,0,0,1,1.8-1.91l32-18.5a5.7,5.7,0,0,1,5.12,0l2.09,1.21A5.61,5.61,0,0,1,444.41,70.21Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M417.81,94.44c.42-.73.88-1.46,1.38-2.2a23.33,23.33,0,0,1,1.62-2.09,19.42,19.42,0,0,1,1.88-1.86,15,15,0,0,1,2.2-1.56,8.22,8.22,0,0,1,2.93-1.1,3.52,3.52,0,0,1,2.27.39,3.57,3.57,0,0,1,1.46,1.8,8.52,8.52,0,0,1,.52,3.18,14.05,14.05,0,0,1-.41,3.47,17.85,17.85,0,0,1-1,3A18.72,18.72,0,0,1,429.3,100c-.48.78-.94,1.51-1.37,2.19s-.81,1.33-1.12,1.93a4.8,4.8,0,0,0-.57,1.74l-.42,3.84-3.13,1.81-.31-3.84a5.27,5.27,0,0,1,.25-2.18,12.33,12.33,0,0,1,1-2.15c.4-.72.85-1.44,1.34-2.18s1-1.5,1.39-2.28a15.82,15.82,0,0,0,1.08-2.42,8,8,0,0,0,.43-2.63,3.5,3.5,0,0,0-.25-1.45,1.64,1.64,0,0,0-.69-.81,1.68,1.68,0,0,0-1.06-.16,3.89,3.89,0,0,0-1.34.5,8.89,8.89,0,0,0-1.79,1.34,14.91,14.91,0,0,0-1.24,1.41c-.33.45-.62.84-.86,1.18a2.16,2.16,0,0,1-.62.67c-.45.26-.77.2-1-.18Zm3.5,24.32a6.29,6.29,0,0,1,.21-1.57,7.47,7.47,0,0,1,.58-1.52,6.5,6.5,0,0,1,.89-1.3,4.21,4.21,0,0,1,1.11-.94,2.18,2.18,0,0,1,1.1-.34,1.52,1.52,0,0,1,.89.28,1.85,1.85,0,0,1,.6.83,3.82,3.82,0,0,1,.22,1.33,6.36,6.36,0,0,1-.22,1.6,7.67,7.67,0,0,1-.6,1.51,6.7,6.7,0,0,1-.89,1.29,4.45,4.45,0,0,1-1.1.92,2.4,2.4,0,0,1-1.11.36,1.35,1.35,0,0,1-.89-.27,1.82,1.82,0,0,1-.58-.83A3.83,3.83,0,0,1,421.31,118.76Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--speech-bubble--inject-44",
    d: "M106.07,154.35c-5.51-8-20.24-14.67-38.45-14.84-16.56-.16-36.73,4.71-41.76,20.62-4.3,13.58,8.93,26.19,22.66,28.87a93.53,93.53,0,0,0,16.58,1.75c2.55,4.76,8.52,7.68,13,8a13.17,13.17,0,0,1-3-8.36,86.19,86.19,0,0,0,12.73-2.15C111.71,182.27,112.23,163.32,106.07,154.35Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.16,72.56c-7.41-10.79-27.22-19.74-51.72-20C90.16,52.38,63,58.93,56.26,80.34c-5.78,18.26,12,35.22,30.5,38.83a127.3,127.3,0,0,0,22.3,2.36c3.42,6.4,11.45,10.33,17.5,10.74a17.82,17.82,0,0,1-4-11.25,115.39,115.39,0,0,0,17.12-2.89C171.75,110.11,172.45,84.63,164.16,72.56Z",
    style: {
      fill: "#ED5802"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.74,80.22a6.65,6.65,0,1,0,6.65,6.65A6.65,6.65,0,0,0,80.74,80.22Zm31.15,0a6.65,6.65,0,1,0,6.65,6.65A6.65,6.65,0,0,0,111.89,80.22Zm31.15,0a6.65,6.65,0,1,0,6.66,6.65A6.65,6.65,0,0,0,143,80.22Z",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesconsultingAmico);
export default __webpack_public_path__ + "static/media/Sales consulting-amico.6a21fe5f0e0218b31a6b9782c367a21d.svg";
export { ForwardRef as ReactComponent };